import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import reportWebVitals from "reportWebVitals";
import "assets/css/common.scss";
import "assets/css/command.scss";
import "assets/css/style.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/dure">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
